import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HHPlatformQueueComponent } from './hh-platform-queue.component';
import { DialogService } from 'primeng/dynamicdialog';
import { QueueActionButtonsComponent } from '@shared/component/queue-action-buttons/queue-action-buttons.component';

@NgModule({
  declarations: [
    HHPlatformQueueComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    QueueActionButtonsComponent,
  ],
  exports: [
    HHPlatformQueueComponent,
  ],
  providers: [
    ConfirmationService, MessageService, DialogService,
  ],
})
export class HHPlatformQueueModule { }
